import { useBeastMode, useFindLoginPage, useLoginV2 } from '#actions/auth';
import { setTimeToLoginEndTime as setTimeToLoginEndTimeAction } from '#actions/timeToLoginMetric';
import withForm from '#components/withForm';
import { useDispatch } from '#hooks/useDispatch';
import type { LoginInfo } from '#utils/loginUtils';
import { createLoginInfo, validateLoginInfo, validateLoginInfoWithEmailOnly } from '#utils/loginUtils';

import type { LoginFormProps } from './LoginForm';
import { LoginForm } from './LoginForm';

const useRedux = () => {
  const dispatch = useDispatch();
  const setTimeToLoginEndTime = (endTime: number) => dispatch(setTimeToLoginEndTimeAction(endTime));
  return {
    setTimeToLoginEndTime,
  };
};

type WrapperProps = {
  onBeastMode?: (info: LoginInfo, redirectPath: string) => void;
  onLoginV2?: (info: LoginInfo, redirectPath?: string) => Promise<void>;
  onGetLoginPage?: (info: LoginInfo, redirectPath?: string) => Promise<unknown>;
  setTimeToLoginEndTime?: (endTime: number) => void;
};

const WrappedLoginForm = withForm<LoginInfo>({
  initialState(props) {
    return createLoginInfo({ username: props.beastModeEmail || '' });
  },
  validate(record, props) {
    return props.requirePassword ? validateLoginInfo(record) : validateLoginInfoWithEmailOnly(record);
  },
  onSubmit(props, modified) {
    let final = modified;
    if (props.beastMode) {
      final = final.set('username', '');
      props.onBeastMode(final, props.redirect);
      return;
    }
    if (props?.requirePassword) {
      props.setTimeToLoginEndTime(Date.now());
    }

    if (!props?.requirePassword) {
      props.onGetLoginPage(final, props.redirect);
    } else {
      props.onLoginV2(final, props.redirect);
    }
  },
})<LoginFormProps, WrapperProps>(LoginForm);

type LoginFormContainerProps = LoginFormProps & {
  redirect?: string;
  beastModeEmail?: string;
};

export function LoginFormContainer(props: LoginFormContainerProps) {
  const onBeastMode = useBeastMode();
  const handleGetLoginPage = useFindLoginPage();
  const onLoginV2 = useLoginV2();
  const { setTimeToLoginEndTime } = useRedux();

  return (
    <WrappedLoginForm
      {...props}
      setTimeToLoginEndTime={setTimeToLoginEndTime}
      onLoginV2={onLoginV2}
      onBeastMode={onBeastMode}
      onGetLoginPage={handleGetLoginPage}
    />
  );
}
